import React from 'react';
import GenericMenu from './source/GenericMenuProject';
import { DOCUMENT_MENU, DOCUMENT_SECTIONS } from './constants/menuStructureProject';

export default function DocumentMenu(props) {
  return (
    <GenericMenu 
      menuConfig={DOCUMENT_MENU} 
      sectionsMap={DOCUMENT_SECTIONS} 
      propsRouter={props} 
    />
  );
}